import { cn } from '@/lib/cn';
import { faQuestionCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Tooltip from 'components/tooltip/Tooltip';
import type { ComponentProps } from 'react';

type Props = Omit<ComponentProps<typeof Tooltip>, 'title'>;

export const DashboardTooltip = (props: Props) => (
    <Tooltip
        {...props}
        title={'Explore built-in dashboards for this data source. Copy them to your workspace to make changes or share with others.'}
        className={cn(props.className, 'inline-block ml-2')}
    >
        <FontAwesomeIcon icon={faQuestionCircle} className='text-textSecondary' />
    </Tooltip>
);
